'use client'
import { useState } from 'react'
import { useRouter } from 'next/navigation'
import Link from 'next/link'
import Image from 'next/image'
import Button from '@/components/Button'

export default function EsqueciSenhaPage() {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const router = useRouter()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setSuccess(false)
    setLoading(true)
    try {
      const res = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      })
      if (!res.ok) {
        setError('Erro ao solicitar recuperação. Tente novamente.')
      } else {
        setSuccess(true)
      }
    } catch {
      setError('Erro de rede.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-black via-zinc-900 to-[#1a1a1a] px-4 py-8">
      <div className="text-center mb-6 w-full max-w-md">
        <Link href="/">
          <Image src="/assets/images/logo.png" alt="Logo Vibe" width={200} height={70} className="mx-auto drop-shadow-lg w-40 sm:w-auto" priority />
        </Link>
      </div>
      <form onSubmit={handleSubmit} className="bg-zinc-900/40 backdrop-blur-xl rounded-3xl border border-zinc-800/50 shadow-2xl p-6 sm:p-8 w-full max-w-md flex flex-col gap-4">
        <h2 className="text-2xl font-bold text-white mb-2 text-center">Recuperar senha</h2>
        <input
          type="email"
          className="w-full px-4 py-3.5 min-h-[48px] text-base bg-zinc-800/50 border border-zinc-700 rounded-xl text-white placeholder-zinc-400 focus:outline-none focus:ring-2 focus:ring-[#ffa300] focus:border-transparent transition-all"
          placeholder="Seu e-mail"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <Button
          type="submit"
          disabled={loading}
        >
          {loading ? 'Enviando...' : 'Enviar link de recuperação'}
        </Button>
        {success && <div className="text-green-400 text-sm text-center mt-2">Se o e-mail existir, você receberá um link para redefinir sua senha.</div>}
        {error && <div className="text-red-400 text-sm text-center mt-2">{error}</div>}
        <button
          type="button"
          className="w-full py-3 min-h-[48px] rounded-full border border-zinc-700 text-zinc-300 font-semibold hover:bg-zinc-800 hover:text-white transition-colors"
          onClick={() => router.push('/login')}
        >
          Voltar para login
        </button>
      </form>
    </div>
  )
} 